<template>
  <div id="map"></div>
</template>

<script>
/*
In order to use the Google Maps API, the corresponding libraries (with addition to 'Places' service)
need to be loaded from within the header on the index page.
<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDB32li1NLpQ3pD5mLzX0HGwzcJy1xfLhg&libraries=places&callback=initMap" async defer/>
In the src of the script element, an API key is required.

To use the Google library in components, it is required to set the library to global in the package.json.
Under the "eslintConfig", add:
"globals": {
"google": true
},
*/
export default {
  name: "GoogleMap",
  props: {
    location: String,
  },
  data() {
    return {
      map: "",
      service: "",
      infoWindow: "",
    };
  },
  methods: {
    async initMap() {
      let infoWindow = new google.maps.InfoWindow();
      let Details = this.$parent;

      let map = new google.maps.Map(document.getElementById("map"), {
        zoom: 18,
        styles: [
          {elementType: "geometry", stylers: [{color: "#242F3E"}]},
          {
            elementType: "labels.text.stroke",
            stylers: [{color: "#242F3E"}],
          },
          {elementType: "labels.text.fill", stylers: [{color: "#746855"}]},
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{color: "#D59563"}],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{color: "#D59563"}],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{color: "#263C3F"}],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{color: "#6B9A76"}],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{color: "#38414E"}],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{color: "#212A37"}],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{color: "#9CA5B3"}],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{color: "#746855"}],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{color: "#1F2835"}],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{color: "#F3D19C"}],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{color: "#2F3948"}],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers: [{color: "#D59563"}],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{color: "#17263C"}],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{color: "#515C6D"}],
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{color: "#17263C"}],
          },
        ],
      });

      let request = {
        query: this.location,
        fields: ["name", "place_id", "geometry"],
      };

      let service = new google.maps.places.PlacesService(map);
      let place_id = "";
      let marker = {};

      service.findPlaceFromQuery(request, function (results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          for (let i = 0; i < results.length; i++) {
            place_id = results[i].place_id;

            marker = new google.maps.Marker({
              map: map,
              position: results[i].geometry.location,
            });
          }
          map.setCenter(results[0].geometry.location);

          let request = {
            placeId: place_id,
            fields: [
              "name",
              "formatted_address",
              "international_phone_number",
              "website",
              "geometry",
            ],
          };

          service.getDetails(request, function (details, status) {
            Details.setCompanyDetails(details);
            google.maps.event.addListener(marker, "click", function () {
              infoWindow.setContent(
                  details.name +
                  "<br />" +
                  details.formatted_address +
                  "<br />" +
                  "<a href='" +
                  details.website +
                  "'>" +
                  "Website" +
                  "</a>" +
                  "<br />" +
                  details.international_phone_number
              );
              infoWindow.open(map, this);
            });
          });
        }
      });
    },
  },
  mounted: function () {
    if (this.location != null) {
      this.initMap();
    }
  },
};
</script>
